import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import ModalFooterActionContainer from '../TripModal/TripItems/Create/ModalFooterActionContainer'

import TextButton from 'LuxKit/Button/TextButton'
import ModalBody from 'LuxKit/Modal/ModalBody'
import ModalContent from 'LuxKit/Modal/ModalContent'
import ModalFooter from 'LuxKit/Modal/ModalFooter'
import ModalHeader from 'LuxKit/Modal/ModalHeader'
import { useScreenSizeOnly } from 'hooks/useScreenSize'
import useModalCallbacks from 'tripPlanner/hooks/View/useModalCallbacks'
import { ItemMetadata } from 'tripPlanner/models'
import type { TripItem } from 'tripPlanner/types/tripItem'

interface Props {
  item: TripItem
  changeItemDates: () => void
}

function ConfirmNavigateToOfferModal(props: Props) {
  const { changeItemDates, item } = props
  const intl = useIntl()
  const { closeModal, goBack } = useModalCallbacks()

  const isMobile = useScreenSizeOnly('mobile')

  return (
    <>
      <ModalHeader
        title={intl.formatMessage(
          {
            id: '4MnENVmHdIi-YrkQdvhX',
            defaultMessage: 'Adjust {itemType}s date',
            description: 'Modal title for adjusting the date of a trip item in the trip planner itinerary view',
          },
          { itemType: intl.formatMessage(ItemMetadata[item.type].singularName).toLowerCase() },
        )}
        onCloseButtonClick={closeModal}
        onBackButtonClick={goBack}
      />
      <ModalBody>
        <ModalContent>
          <FormattedMessage
            id="QY1QYRXsQzGYEsa0wDi2"
            defaultMessage="You will be taken to the <bold>{itemName}</bold> to adjust the dates for your stay"
            description="Explanation that the user will be redirected to the offer page to change dates"
            values={{
              itemName: item.sortableName,
              bold: (chunks: React.ReactNode) => <b>{chunks}</b>,
            }}
          />
        </ModalContent>
      </ModalBody>
      <ModalFooter>
        <ModalFooterActionContainer>
          <TextButton
            kind="secondary"
            size="large"
            fit={`${isMobile ? 'full-width' : 'auto'}`}
            onClick={closeModal}
          >
            {intl.formatMessage({
              id: 'TQOrj1bsaiHJnsJQX3Sm',
              defaultMessage: 'Cancel',
              description: 'Action button to dismiss the adjust item dates modal',
            })}
          </TextButton>
          <TextButton
            kind="primary"
            size="large"
            fit={`${isMobile ? 'full-width' : 'auto'}`}
            onClick={changeItemDates}
          >
            {intl.formatMessage({
              id: 'kPsiIimeDHx885DOwdVv',
              defaultMessage: 'Continue',
              description: 'Button to continue to the offer page to adjust dates',
            })}
          </TextButton>
        </ModalFooterActionContainer>
      </ModalFooter>
    </>
  )
}

export default ConfirmNavigateToOfferModal
